import { boot } from 'quasar/wrappers'
import { helpers } from 'src/boot/helper'

// Routes reachable without a token: login, the two password-recovery flows
// (OTP link and magiclink) and the MSAL callback.
const MAGICLINK_ROUTES = ['FirstLogin', 'SetPassword']

const PUBLIC_ROUTES = [
  'Login',
  'ResetPassword',
  'callback',
  ...MAGICLINK_ROUTES
]

export default boot(({ router, store }) => {
  router.beforeEach((to, from, next) => {
    const token = store.getters['reporter/token'] || null
    // The magiclink flow must survive a stale token left in the store: validating
    // it here would log the user out and drop the `?magic=` token on the way.
    if (MAGICLINK_ROUTES.includes(to.name)) {
      next()
    } else if (!token && !PUBLIC_ROUTES.includes(to.name)) {
      next('/login')
    } else if (token) {
      helpers
        .isTokenValid(token)
        .then(() => {
          if (to.name === 'login' && from.name === 'issueDetail') {
            console.error('routerGard anomaly detected')
            next({ path: '/history' })
          } else {
            next()
          }
        })
        .catch(() => {
          store.dispatch('reporter/logout')
          next('/login')
        })
    } else {
      next()
    }
  })
})
